import settings from '../common/settings';

import { isPayRetailers } from '../common/isPayRetailers';

function initialize() {
  setupRecoveryPasswordForm();
}

function setupRecoveryPasswordForm() {
  $('form[name=recoveryPasswordForm]').on('submit', function (e) {
    e.preventDefault();

    $('#validationFailedNotification').addClass('hide');
    $('#errorNotification').addClass('hide');

    const email = $('input[name=email]').val();

    if (email && email.trim()) {
      $.ajax({
        url: `${settings.url.api.login}/password/recovery`,
        type: 'post',
        data: {
          email: email.trim(),
          isPayRetailers: isPayRetailers()
        },
        headers: {
          Accept: 'application/vnd.login.v1+json'
        },
        dataType: 'json',
        success: onSuccess,
        error: onError
      });
    }

    function onSuccess() {
      $('#successNotification').removeClass('hide');
      $('input[type=email]').val('');
    }

    function onError(err) {
      if (err.status === 400) {
        $('#validationFailedNotification').removeClass('hide');
      } else {
        $('#errorNotification').removeClass('hide');
      }
    }
  });
}

initialize();
